import React, { useEffect, useState } from 'react'
import { useFieldArray } from 'react-hook-form'
import { SelectField, TextField } from '../Base/Form'

const PromoFields = ({
  control,
  handleNoPromo,
  dictionary,
  promoCodeTypeOptions,
  isMobile,
}) => {
  const [currentTypes, setCurrentTypes] = useState(['', ''])
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'promos',
  })

  const handleAddPromo = () => {
    append({ promoType: '', promoNumber: '' })
  }

  useEffect(() => {
    if (fields?.length < 1) handleAddPromo()
  }, [])

  const handleRemovePromo = (index) => {
    if (fields?.length === 1) {
      handleNoPromo()
    }
    remove(index)
    const newTypes = [...currentTypes]
    newTypes[index] = ''
    setCurrentTypes(newTypes)
  }

  const handleChange = (e, index) => {
    const newTypes = [...currentTypes]
    newTypes[index] = e.target.value
    setCurrentTypes(newTypes)
  }

  return (
    <>
      {fields?.map((field, index) => (
        <div key={field.id} className="s-booking-widget__promo__record">
          <div className="s-booking-widget__promo__inputs">
            <SelectField
              name={`promos[${index}].type`}
              control={control}
              label={dictionary.promoCodeTypeLabel}
              options={promoCodeTypeOptions?.map((opt) =>
                (index === 0 && opt.value === currentTypes[1]) ||
                (index === 1 && opt.value === currentTypes[0])
                  ? { ...opt, disabled: true }
                  : opt
              )}
              onChange={(e) => handleChange(e, index)}
            />

            <TextField
              label={dictionary.promoCodeLabel}
              name={`promos[${index}].code`}
              control={control}
              info={isMobile ? null : dictionary.promoCodeInfo}
            />
          </div>

          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-secondary p-0"
              onClick={() => handleRemovePromo(index)}>
              <i className="icon icon-x"></i>
              {!isMobile && (
                <span className="px-3">{dictionary.removePromoCodeBtn}</span>
              )}
            </button>
          </div>
        </div>
      ))}
      {fields?.length < 2 && (
        <button
          type="button"
          className="btn btn-secondary s-booking-widget__add-promo"
          onClick={handleAddPromo}
          title={dictionary.addPromoCodeBtn}>
          {dictionary.addPromoCodeBtn}
        </button>
      )}
    </>
  )
}

export default PromoFields
